import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { TrustBar } from '../components/TrustBar';
import { Services } from '../components/Services';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { HowItWorks } from '../components/HowItWorks';
import { Gallery } from '../components/Gallery';
import { Testimonials } from '../components/Testimonials';
import { Faq } from '../components/Faq';
import { ContactSection } from '../components/ContactSection';
import { AreasSection } from '../components/AreasSection';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Seo } from '../components/Seo';
import { HOME_KEYWORDS, SITE_URL, faqSchema, localBusinessSchema } from '../data/schema';
const homeSchemas = [localBusinessSchema, faqSchema];
export function Home() {
  return <>
      <Seo title="Junk Removal San Francisco, CA | Same-Day Service | Armando's Hauling" description="Affordable junk removal in San Francisco. Same-day service, free estimates. Furniture removal, construction debris, garage cleanouts, demolition. Licensed & insured. Se habla español. Call 415-745-6692." keywords={HOME_KEYWORDS} canonical={`${SITE_URL}/`} ogTitle="Junk Removal San Francisco | Armando's Hauling" ogDescription="Same-day junk removal in San Francisco. Free estimates. Call 415-745-6692." jsonLd={homeSchemas} data-id="element-258" data-mp="3ovub9vog9pkb" />
      <Navbar data-id="element-259" data-mp="2d6xdg27naewv" />
      <main data-id="element-260" data-mp="2d65r7hzxttj9">
        <Hero data-id="element-261" data-mp="2d5mcea5l3l9g" />
        <TrustBar data-id="element-262" data-mp="2d5460kp7jqnt" />
        <Services data-id="element-263" data-mp="2883zy9scynwp" />
        <WhyChooseUs data-id="element-264" data-mp="287krdjollbvc" />
        <HowItWorks data-id="element-265" data-mp="2895mbaetqwtq" />
        <Gallery data-id="element-266" data-mp="288dqpzl88z3g" />
        <Testimonials data-id="element-267" data-mp="285rjy265unma" />
        <Faq data-id="element-268" data-mp="239axrdiiujbu" />
        <ContactSection data-id="element-269" data-mp="239soxvqbu7cw" />
        <AreasSection data-id="element-270" data-mp="23acbjpqx9jx9" />
      </main>
      <Footer data-id="element-271" data-mp="2376jq2qws3xu" />
      <WhatsAppButton data-id="element-272" data-mp="1z7662kbmvwru" />
    </>;
}